export const MAX_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
